import React from 'react'
import RequirementForm from '../components/BulkQuote/RequirementForm'
import HeroBanner from '../components/BulkQuote/HeroBanner'
import CmsPageHero from '../components/CmsPageHero'

const BulkQuote = () => {
  return (
    <>
    <CmsPageHero slug="bulk-quote"><HeroBanner/></CmsPageHero>
    <RequirementForm/>
    </>
  )
}

export default BulkQuote 
